<template>
  <div style="background: #f9f9f9">
    <!--    <img src="./print.svg" alt="" style="width: 100%;">-->

    <div class="printBanner">
      <div style="height: 170px">
        <div class="container" >
          <el-row :gutter="30" style="padding-top: 50px">
            <el-col :span="12" :offset="6" class="bannerSearch">
              <el-input
                size="large"
                placeholder="请输入内容"
                v-model="input"
                class=""
                @keyup.native.enter="searchServerName"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchServerName"
                  type="primary"
                ></el-button>
              </el-input>
              <ul class="flex" style="font-size: 12px; color: #fff">
                <li style="margin: 15px; margin-left: 0px; cursor: pointer" @click="searchByKeyword(items)" v-for="(items, index) in keywords">{{ items }}</li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="container">
      <section style="margin-top: 30px" class="container_box flex">
        <div class="container_left">
          <p
            class="containerP"
            v-for="(items, index) in serverList"
            :key="index"
          >
            {{ items.name }}
          </p>
        </div>
        <div class="container_right">
          <div class="container_right_title">
			  <!-- 当前位置：我要打印>服务列表 -->
			  <span>当前位置：</span>
			  <el-breadcrumb separator=">">
				<el-breadcrumb-item :to="{ path: '/print' }">我要打印</el-breadcrumb-item>
				<el-breadcrumb-item >全部服务</el-breadcrumb-item>
			  </el-breadcrumb>
			  </div>
          <div class="container_right_content flex">
            <p
              v-for="(severs, indexser) in serverList[sercerIndex]
                .serverMessage"
              :key="indexser"
              @click="getServerTops(indexser,severs.uuid)"
              :class="indexserIndex == indexser ? 'container_rightActive' : ''"
            >
              {{ severs.name }}
            </p>
          </div>
          <div class="container_right_content flex">
            <p
              v-for="(seversall, indexsers) in serverList[sercerIndex]
                .serverAll"
              :key="indexsers"
              @click="getServerTops2(indexsers,seversall.uuid)"
              :class="
                indexsersIndex == indexsers ? 'container_rightActive' : ''
              "
            >
              {{ seversall.name }}
            </p>
          </div>
        </div>
      </section>
    </div>

    <div class="container">
       <div v-if="empty" style="text-align:center;margin-bottom:20px" >
          <img src="../../assets/暂无搜索内容.jpg" alt="" style="width:200px">
        </div>
      <section style="padding: 0 0 60px 0" v-if="empty!=true">
        <el-row style="display: flex;flex-wrap: wrap;" :gutter="30">
          <el-col :span="6"
                  v-for="(items, index) in hotServeList"
                  @click.native="getServiceDetails(items.uuid)"
                  :key="index">
            <el-card
              class="box-card"
              shadow="hover"
              :body-style="{ padding: '0px' }"
            >
              <div class="image" v-if="items.urlList.length > 0">
                <img :src="items.urlList[0].urlPath" alt=""/>
              </div>
              <div style="padding: 15px">
                <h4 class="mpTitle">{{ items.serviceName }}</h4>
                <p class="mpComp">{{ items.enterPriseName }}</p>
                <dl class="mpDetail clearfix">
                  <dt>服务行业：</dt>
                  <dd>{{items.serviceTradeName| ellipsisService}}</dd>
                </dl>
                <p class="mpPrice">¥{{ items.servicePrice }} <span>议价</span></p>
                <div class="mpFooter">
                  <span
                    ><a href="#"
                      ><i class="el-icon-view" style="margin-right: 8px"></i
                      >浏览量：{{ items.pageViews }}</a
                    ></span
                  >
                  <span
                    ><a href="#"
                      ><i class="el-icon-star-off" style="margin-right: 8px"></i
                      >收藏量：{{ items.collectionVolume }}</a
                    ></span
                  >
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <div style="text-align: right">
          <el-pagination
              background
              @current-change="handleCurrentChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="current"
              :page-size="pageSize"
              :total="total" class="pagination">
          </el-pagination>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getServiceabilityList,
  getDictionaryItem, getDictionaryGroup } from '../../utils/interface';
export default {
  //   热门服务列表页
  name: "printList",
  metaInfo: {
    title: '服务列表 -我要打印-3D打印服务-为用户提供定制化、快速报价等一站式3D打印服务-增材云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '3D打印服务 |工业制造 | 金属 |高分子材料 |3D打印材料有哪些种类 | 3D打印设备  | 型砂 | 光敏树脂'
    },
      {                 // set meta
        name: 'description',
        content: '增材云-基础服务覆盖多种打印工艺材料，为增材制造领域不同行业用户提供定制化、快速报价等一站式3D打印服务'
      }],
  },
  components: {},
  data() {
    return {
      keywords:[],
      empty:false,
      input: "",
      groupCode: "print_banner",
      technologyCode:'server_print',
      parentCode: 'material_print',
      current:1,
      total: 0,
      pageSize: 12,
      materialId:'',
      serviceId:'',
      // 热门服务
      hotServeList: [],
      // 顶部分类
      sercerIndex: 0,
      indexserIndex: 0,
      indexsersIndex: 0,
      serverList: [
        {
          name: "服务列表",
          serverMessage: [],
          serverAll: [],
        },
        {
          name: "服务行业",
        },
        {
          name: "材料类型",
        },
      ],
    };
  },
  created(){
    // 服务行业
    this.getItemList();
    // 材料类型
    this.getDictionaryGroup();
    // 查询热门服务
    this.getServiceabilityList();
  },
  filters: {
    ellipsisService(value) {
      if (!value) return '';
      if (value.length > 10) {
        return value.slice(0, 10) + '...'
      }
      return value;
    }
  },
  methods: {
    searchServerName(){
      this.current = 1;
      this.getServiceabilityList();

    },
    getServiceabilityList(){
      let params = {
        materialId:this.materialId,
        serviceId:this.serviceId,
        current:this.current,
        pageSize:this.pageSize,
        serviceName:this.input
      };
      getServiceabilityList(params).then((res)=>{
        this.hotServeList = res.list;
        this.total = res.total;
        this.pageSize = res.size;
        this.current = res.current;
        if(this.hotServeList==0){
          this.empty=true
        }else{
          this.empty=false
        }
      });
    },
    // 分页
    handleCurrentChange(val){
      this.current = val;
	  window.scrollTo(0,0);
      this.getServiceabilityList()
    },
    getItemList(){
      let params = {
        groupCode: this.technologyCode,
      };
      getDictionaryItem(params).then((res) => {
        this.serverList[0].serverMessage = res;
        this.serverList[0].serverMessage.unshift({uuid:'',name:'全部'});
      });
      getDictionaryItem({groupCode: 'service_keyword'}).then((res)=>{
        // let re = [];
        if(res != null && res.length > 0){
          res.forEach((item, index) => {
            this.keywords.push(item.name);
          });
        }
      });
    },
    searchByKeyword(keyword){
      this.input = keyword;
      this.searchServerName();
    },
    getDictionaryGroup() {
      let params = {
        parentCode: this.parentCode,
      };
      getDictionaryGroup(params).then((res) => {
        this.serverList[0].serverAll = res;
        this.serverList[0].serverAll.unshift({uuid:'',name:'全部'});
      });
    },
    getServerTops(i,uuid) {
      this.indexserIndex = i;
      this.current = 1;
      this.serviceId = uuid;
      this.getServiceabilityList();
    },
    getServerTops2(i,uuid) {
      this.current = 1;
      this.materialId = uuid;
      this.indexsersIndex = i;
      this.getServiceabilityList();
    },
    getServiceDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "printServiceDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.printBanner {
  background: url("../../assets/image/fulist.png");
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.container_box {
  font-size: 14px;
  background: #fff;
  margin-bottom: 40px;
  color: #555;
  .container_left {
    border-right: 1px solid #f2f5fa;
    p {
      width: 215px;
      height: 44px;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid #f2f5fa;
    }
    p:nth-last-child(1) {
      border-bottom: none;
    }
    .containerP:nth-child(1) {
      background: #cbe0f9;
      color: #157efb;
    }
  }
  .container_right {
    width: 100%;

    .container_right_title {
      border-bottom: 1px solid #f2f5fa;
      height: 44px;
      line-height: 40px;
      font-size: 14px;
      padding-left: 34px;
      color: #808080;
	  display: flex;
	  align-items: center;
    }
    .container_right_content {
      border-bottom: 1px solid #f2f5fa;
      align-items: center;
      height: 44px;
      p {
        cursor: pointer;

        height: 30px;
        width: 98px;
        text-align: center;
        line-height: 30px;
        margin-right: 25px;
      }
      p:nth-child(1) {
        margin-left: 34px;
      }
      .container_rightActive {
        background: #157efb;
        color: #fff;
        border-radius: 5px;
      }
    }
    .container_right_content:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
.leftCont {
  margin-top: 30px;
  .leftCard {
    margin-bottom: 30px;
    border: none;
    /deep/.el-card__header {
      color: #157efb;
      background-color: #f3f3f3;
      font-size: 18px;
      padding: 12px 20px;
    }
    /deep/.el-card__body {
      background-color: #fbfbfb;
    }
  }
  .servInfo h3 {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 15px;
  }
  .servInfo .eval li {
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
  }
  .servInfo .eval li span {
    margin-right: 30px;
  }
  .servInfo .contact {
    margin-top: 30px;
    margin-bottom: -10px;
    font-size: 12px;
  }
  .servInfo .contact i {
    margin-right: 5px;
  }
  .servInfo .contact p {
    font-size: 14px;
    margin-bottom: 10px;
  }
}
.bannerSearch {
  /deep/.el-input__inner {
    height: 50px;
    line-height: 50px;
  }
  /deep/.el-input-group__append {
    background-color: #157efb;
    color: #fff !important;
    font-size: 18px;
    border-color: transparent;
  }
}
.printTitle {
  font-size: 24px;
  font-weight: normal;
  color: #157efb;
  margin-top: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;
  span.tit {
    padding-bottom: 10px;
    border-bottom: 1px solid #157efb;
  }
  span.more {
    font-size: 16px;
    float: right;
    margin-top: 10px;
  }
  .more i {
    color: #505050 !important;
  }
}
.hotSell {
  margin-bottom: -30px;
  li {
    margin-bottom: 30px;
  }
  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
  }
  .topServBoxInfo p {
    font-size: 12px;
    color: #aaa;
  }
}
.relateServ {
  margin-bottom: -30px;
  li {
    margin-bottom: 30px;
  }
  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
  }
}
.topServBox {
  background-color: #fff;
  height: 200px;
  border-radius: 8px;
  box-shadow: 0 1px 5px #eaeaea;
  margin-top: -100px;
  padding: 30px;
  box-sizing: border-box;
  .topServBoxInfo h3 {
    font-size: 16px;
    margin-bottom: 6px;
    font-weight: normal;
  }
  .topServBoxInfo p {
    font-size: 12px;
    color: #585858;
  }
  /deep/.el-menu.el-menu--horizontal {
    border-color: transparent;
  }
  /deep/.el-menu--horizontal > .el-menu-item.is-active {
    border: none !important;
    background-color: #f3f8ff;
    border-radius: 5px;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    height: 30px;
    line-height: 26px;
  }
}
.topServBoxNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  p:first-child {
    font-size: 16px;
  }
  p:last-child {
    font-size: 12px;
    color: #585858;
  }
}
.menu-sub {
  margin-top: 35px;
  font-size: 16px;
}
.box-card {
  margin-bottom: 30px;
  position: relative;
  cursor: pointer;
  .image {
    width: 100%;
    height: 200px;
    display: block;
    overflow: hidden;
    img {
      width: 100%;
      transition: all 1s;
    }
  }
}
.box-card:hover {
  .image {
    img {
      transform: scale(1.2);
    }
  }
}
.compInfo p {
  text-indent: 2em;
  font-size: 14px;
  line-height: 1.8;
  color: #808080;
}
.mpBox {
  display: flex;
  align-items: center;
}
.mpCheck {
  position: absolute;
  right: 20px;
  top: 20px;
}
.mpTitle {
  font-size: 16px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mpComp {
  margin-top: 10px;
  font-size: 13px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.mpPrice {
  margin: 10px 0;
  font-size: 13px;
  color: #da251d;
  span {
    color: #000;
    margin-left: 10px;
  }
}
.mpDetail {
  margin-top: 10px;
  dt {
    float: left;
    width: 70px;
    color: #000;
    font-size: 13px;
    font-weight: normal;
    line-height: 22px !important;
  }
  dd {
    font-size: 13px;
    line-height: 22px !important;
    margin-left: 70px;
    margin-bottom: 5px;
    color: #808080;
  }
}
.mpFooter-v1 {
  text-align: center;
  font-size: 14px;
  background: #f1f5fe;
  border: 1px solid #ebeef5;
  margin: -10px -21px -21px;
  height: 50px;
  line-height: 50px;
}
.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-top: 1px solid #e3e3e3;
  margin: 0 0 -15px;
  position: relative;
  span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 13px;
    height: 50px;
    line-height: 50px;
  }
  span a {
    font-size: 12px;
    color: #808080;
  }
  span a:hover {
    color: rgba(21, 126, 251, 0.8);
  }
  :after {
    position: absolute;
    content: "";
    width: 1px;
    background-color: #e3e3e3;
    height: 34px;
    top: 8px;
    left: 50%;
  }
}
.printBox {
  /deep/.el-input--suffix .el-input__inner {
    padding: 0 15px;
  }
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
a {
  color: #157efb;
}
a:hover {
  color: rgba(21, 126, 251, 0.8);
}
.mpTime {
  font-size: 12px;
  color: #aaa;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/print/printList.vue